<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <h1>{{ 'TO.NewCustomer_NewCustomer' | translate : 'New Customer'}}</h1>
  <mat-accordion style="padding:10px;">

    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header [ngClass]="{'border-invalid' : !customerForm.valid && saveDirty}">
        <mat-panel-title> {{'TO.NewCustomer_CustomerInfo_Title' | translate : 'Customer info'}}</mat-panel-title>
        <mat-panel-description>
          {{'TO.NewCustomer_CustomerInfo_Description' | translate : 'Customer and organisation information'}}
          <div style="display:flex; gap:15px;">
            <mat-icon *ngIf="!customerForm.valid" style="color:red;">close</mat-icon>
            <mat-icon *ngIf="customerForm.valid" style="color:green;">check</mat-icon>
            <mat-icon>account_circle</mat-icon>
          </div>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="col-md-12" style="margin-top: 15px;" [formGroup]="customerForm">
        <div class="row">
          <!-- Group -->
          <div class="col-5" style="margin-bottom:10px;">
            <mat-form-field style="width: 100%;" appearance="outline" >
              <mat-label>{{'TO.NewCustomer_Group_Lable' | translate : 'Group'}}</mat-label>
              <input #groupInput
                     type="text"
                     placeholder="Select group"
                     matInput
                     [matAutocomplete]="groupAuto"
                     (input)="groupFilter()"
                     (focus)="groupFilter()"
                     formControlName="Group">
              <mat-icon matSuffix>arrow_drop_down</mat-icon>
              <mat-autocomplete requireSelection #groupAuto="matAutocomplete">
                <mat-option *ngFor="let option of filteredGroupOptions" [value]="option.Name">
                  {{ option.Name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Chain -->
          <div class="col-5" style="margin-bottom:10px;">
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-label>{{'TO.NewCustomer_Chain_Lable' | translate : 'Chain'}}</mat-label>
              <input #chainInput
                     type="text"
                     placeholder="Select chain"
                     matInput
                     [matAutocomplete]="chainAuto"
                     (input)="chainFilter()"
                     (focus)="chainFilter()"
                     formControlName="Chain">
              <mat-icon matSuffix>arrow_drop_down</mat-icon>
              <mat-autocomplete requireSelection #chainAuto="matAutocomplete">
                <mat-option *ngFor="let option of filteredChainOptions" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- OrgNo -->
          <div class="col-5">
            <mat-form-field style="width: 100%; margin-bottom: 5px;" appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_OrgNo' | translate : 'Org. no.' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_OrgNo' | translate : 'Org. no.' }}"
                     type="text" formControlName="OrgNo" />
            </mat-form-field>
          </div>

          <!-- FilialNr -->
          <div class="col-5">
            <mat-form-field style="width: 100%; margin-bottom: 5px;" appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Filial' | translate : 'Filial number' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Filial' | translate : 'Filial number' }}"
                     type="text" formControlName="FilialNr" />
            </mat-form-field>
          </div>
        </div>

        <div class="row" style="margin-top:20px;">
          <!-- Comment -->
          <div class="col-5">
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Comments' | translate : 'Comments' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Comments' | translate : 'Comments' }}"
                     type="text" formControlName="Comment" />
            </mat-form-field>
          </div>

          <!-- Payment -->
          <div class="col-5" style="align-content: center;">
            <mat-checkbox formControlName="Payment">
              {{'TO.NewCustomer_Payment' | translate : 'Are we paying out money to the customer? (Paythrough, Kickback, Profitshare etc)'}}
            </mat-checkbox>
          </div>
        </div>
      </div>

    </mat-expansion-panel>
    </mat-accordion>
  <mat-accordion style="padding:10px;">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header [ngClass]="{'border-invalid' : (!invoiceForm.valid || !deliveryForm.valid) && saveDirty}">
        <mat-panel-title>{{ 'TO.NewCustomer_AddressInfo_Title' | translate : 'Address'}}</mat-panel-title>
        <mat-panel-description>
          {{'TO.NewCustomer_InvoiceDeliveryAddress_Title' | translate: 'Invoice and delivery address'}}
          <div style="display:flex; gap:15px;">
            <mat-icon *ngIf="!invoiceForm.valid || !deliveryForm.valid" style="color:red;">close</mat-icon>
            <mat-icon *ngIf="invoiceForm.valid && deliveryForm.valid" style="color:green;">check</mat-icon>
            <mat-icon>pin_drop</mat-icon>
          </div>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="col-md-12">
        <div class="row">

          <div class="col-5 invoice-address" [formGroup]="invoiceForm">
            <h2>{{ 'TO.NewCustomer_InvoiceAddress_Title' | translate : 'Invoice address' }}</h2>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Company' | translate : 'Company name' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Company' | translate : 'Company name' }}"
                     formControlName="InvoiceName" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Address' | translate : 'Address' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Address' | translate : 'Address' }}"
                     formControlName="InvoiceAddress" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Zipcode' | translate : 'Zip code' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Zipcode' | translate : 'Zip code' }}"
                     formControlName="InvoiceZipCode" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_City' | translate : 'City' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_City' | translate : 'City' }}"
                     formControlName="InvoiceCity" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Mail' | translate : 'Email' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Mail' | translate : 'Email' }}"
                     formControlName="Mail" />
              <mat-error *ngIf="invoiceForm.get('Mail')?.hasError('email')">
                Enter a valid email.
              </mat-error>
            </mat-form-field>

          </div>

          <mat-divider [vertical]="true"></mat-divider>

          <div class="col-5 delivery-address" [formGroup]="deliveryForm">
            <h2>{{ 'TO.NewCustomer_DeliveryAddress_Title' | translate : 'Delivery address' }}</h2>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Company' | translate : 'Company name' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Company' | translate : 'Company name' }}"
                     formControlName="DeliveryAddressCustomerName" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Address' | translate : 'Address' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Address' | translate : 'Address' }}"
                     formControlName="DeliveryAddress" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_ZipCode' | translate : 'Zip code' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_ZipCode' | translate : 'Zip code' }}"
                     formControlName="DeliveryZipCode" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_City' | translate : 'City' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_City' | translate : 'City' }}"
                     formControlName="DeliveryCity" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Mail' | translate : 'Email' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Mail' | translate : 'Email' }}"
                     formControlName="InvoiceAccount" />
              <mat-error *ngIf="deliveryForm.get('InvoiceAccount')?.hasError('email')">
                Enter a valid email.
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.NewCustomer_Phone' | translate : 'Phone' }}</mat-label>
              <input matInput placeholder="{{ 'TO.NewCustomer_Phone' | translate : 'Phone' }}"
                     formControlName="Phone" />
              <mat-error *ngIf="deliveryForm.get('Phone')?.hasError('pattern')">
                Enter a valid phone number.
              </mat-error>
            </mat-form-field>
          </div>

        </div>
      </div>
    </mat-expansion-panel>
    </mat-accordion>
      <mat-accordion>
        <mat-expansion-panel expanded="true" [disabled]="!customerForm.get('Payment')?.value">
          <mat-expansion-panel-header [ngClass]="{'border-invalid' : !paymentForm.valid && saveDirty && customerForm.get('Payment')?.value}">
            <mat-panel-title> {{'TO.NewCustomer_Payement_Title' | translate: 'Payment'}}</mat-panel-title>
            <mat-panel-description>
              {{'TO.NewCustomer_PaymentSettings_Title' | translate: 'Payment settings'}}
              <div style="display:flex; gap:15px;">
                <mat-icon *ngIf="customerForm.get('Payment')?.value && (!paymentForm.valid)" style="color:red;">close</mat-icon>
                <mat-icon *ngIf="customerForm.get('Payment')?.value && (paymentForm.valid)" style="color:green;">check</mat-icon>
                <mat-icon>payments</mat-icon>
              </div>

            </mat-panel-description>
          </mat-expansion-panel-header>

        <div class="settingsSection" style="margin-top: 15px;">
          <h2>{{'TO.NewCustomer_Payment_PayoutInfo' | translate: 'Payout info'}}</h2>
          <form [formGroup]="paymentForm">
            <div formArrayName="payouts">
              <div *ngFor="let payout of payouts.controls; let i = index" [formGroupName]="i" class="row">
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Type</mat-label>
                    <select matNativeControl formControlName="type">
                      <option *ngFor="let option of getAvailableOptions(payout.get('type')?.value)" [value]="option">
                        {{ option }}
                      </option>
                    </select>
                  </mat-form-field>
                </div>
                <div class="col-5" style="margin-left:10px;">
                  <mat-form-field appearance="outline" style="width:100%; margin-bottom:10px;">
                    <mat-label>Payout Info</mat-label>
                    <input matInput type="text" formControlName="payoutInfo"/>
                  </mat-form-field>
                </div>
                <button mat-icon-button color="warn" (click)="removeInput(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

            <button mat-raised-button color="primary" (click)="addInput()" [disabled]="!customerForm.get('Payment')?.value">
              {{'TO_NewCustomer_Add_Button' | translate : 'Add'}}Add <mat-icon>add</mat-icon>
            </button>
          </form>
        </div>

        </mat-expansion-panel>

      </mat-accordion>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-xs-12" style="text-align: right">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()">{{ 'turbo.core.RentalDialog.cmdSave' | translate : 'Save'}}</button>
    <button mat-stroked-button color="primary" style="margin: 3px;" [mat-dialog-close]>{{ 'turbo.core.RentalDialog.cmdCancel' | translate : 'Cancel'}}</button>
  </div>
</mat-dialog-actions>
